function initializeVideoGridSections() {
  // Select all video grid sections
  var gridSections = document.querySelectorAll(".video-grid-section");

  gridSections.forEach(function(section) {
    // Check if the section has already been initialized
    if (section.dataset.initialized) {
      return;
    }
    // Mark the section as initialized
    section.dataset.initialized = true;

    // Find the section header in the section
    var sectionHeader = section.querySelector(".video-section-header");

    // Find the video grid in the section
    var videoGrid = section.querySelector(".video-grid");

    // Add event listener to toggle the corresponding video grid
    if (sectionHeader && videoGrid) {
     sectionHeader.addEventListener("click", function() {
  videoGrid.classList.toggle("hidden");
  sectionHeader.classList.toggle("open");

  // Update aria-expanded attribute
  var isExpanded = sectionHeader.classList.contains("open");
  sectionHeader.setAttribute("aria-expanded", isExpanded);
});
    }
  });
}

// Initialize on page load
document.addEventListener("DOMContentLoaded", function() {
  initializeVideoGridSections();
});

// Re-initialize when a section is added or reloaded (for Theme Editor)
document.addEventListener('shopify:section:load', function(event) {
  initializeVideoGridSections();
});
